import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Maximize2 } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { workPhotos, photoById, photoLabel } from "@/data/portfolio";
import { WorkPhoto } from "./WorkPhoto";
import { PhotoLightbox } from "./LazyPhotoLightbox";
import { Reveal } from "./Reveal";

export const WorkPreview = () => {
  const { t } = useLanguage();
  const [index, setIndex] = useState(null);
  return <section data-testid="real-work-section" className="studio-section !pt-12 bg-white">
    <div className="studio-container">
      <Reveal className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-10">
        <div><p className="studio-eyebrow">Shylov Cleaning · {workPhotos.length} {t("studio.photos")}</p>
          <h2 className="studio-heading" data-testid="real-work-heading">{t("studio.workTitle")}</h2>
          <p className="text-slate-500 text-sm mt-4 max-w-md">{t("studio.workIntro")}</p>
        </div>
        <Link to="/gallery" data-testid="view-all-work" className="studio-text-link">{t("studio.browse")}<ArrowUpRight size={18} /></Link>
      </Reveal>
      <div className="grid md:grid-cols-12 gap-8 items-start">
        {["detailing-01", "apartment-12"].map((id, position) => {
          const photo = photoById(id);
          return <Reveal key={id} delay={position * 0.1} className={position ? "md:col-span-5 md:pt-16" : "md:col-span-7"}>
            <button type="button" data-testid={`preview-open-${id}`} aria-label={`${t("gallery.view")}: ${photoLabel(photo, t)}`}
              onClick={() => setIndex(workPhotos.findIndex(item => item.id === id))} className="work-photo-button w-full">
              <WorkPhoto photo={photo} testId={`preview-photo-${id}`} className="w-full h-auto" sizes="(max-width: 768px) 100vw, 60vw" />
              <span className="photo-expand" aria-hidden="true"><Maximize2 size={20} /></span>
            </button>
            <div className="pt-5 flex justify-between items-start gap-4 border-b border-slate-200 pb-5">
              <div><p className="text-xs text-slate-500 mb-2">0{position + 1} / Shylov Cleaning</p>
                <h3 className="font-heading font-semibold text-navy-900">{t(`services.items.${photo.service === "detailing" ? "detailing" : "apartment"}.title`)}</h3></div>
              <Link to={`/gallery?category=${photo.category}`} data-testid={`preview-gallery-${photo.category}`} aria-label={t("studio.browse")} className="studio-icon-link"><ArrowUpRight size={20} /></Link>
            </div>
          </Reveal>;
        })}
      </div>
    </div>
    <PhotoLightbox photos={workPhotos} index={index} onIndexChange={setIndex} onClose={() => setIndex(null)} />
  </section>;
};